<div class="browsers-table">
	<app-datatable-v3
		[sectiontitle]="sectiontitle"
		[datatableconfig]="datatableconfig"
		[key]="tertiarykey"
		[downloadcsvcolumns]="downloadSecondaryCSVColumns"
	>
	</app-datatable-v3>
</div>
<div class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary c-portlet_box_specs v3-portlet">
	<div class="cards-holder devices-tab" (window:resize)="onResize($event)">
		<div class="card card2 mRight" id="display-creative-v3-chart-container">
			<app-loader [showLoader]="showLoad"></app-loader>
			<div *ngIf="!hasData">
				<img [src]="placeholderimage" class="no-creative-data" />
			</div>
			<div class="c-portlet__header">
				<div class="o-stack__cell">
					<h5 class="card-title">Device Breakdown</h5>
					<span class="datatable-icon">
						<a
							href="javascript:void(0)"
							class="datatable_download_icon"
							(click)="downloadCsv($event)"
							target="_blank"
							*ngIf="devicedatatableconfig && devicedatatableconfig.enableDownload"
						>
							<i class="fa fa-download" aria-hidden="true"></i>
						</a>
					</span>
					<div class="legend-area" *ngIf="legend.length > 0">
						Metric:
						<select
							id="metricLegend"
							[(ngModel)]="selectedEmailLegendName"
							(change)="processSelectedLegendItem($event.target.value)"
						>
							<option *ngFor="let legendItem of legend" value="{{ legendItem?.value }}">
								{{ legendItem?.displayName }}
							</option>
						</select>
					</div>
				</div>
			</div>
			<div [hidden]="!hasData || !selectedGraphData" #chartcontainer class="donut-div">
				<h4 *ngIf="selectedGraphData && !isPreroll" class="device-series-titlename">
					{{ selectedGraphData.seriesName | titlecase }} by Device
				</h4>
				<h4 *ngIf="selectedGraphData && isPreroll" class="device-series-titlename">
					{{ selectedGraphData.seriesName }} by Device
				</h4>
				<app-donut
					*ngIf="selectedGraphData && selectedGraphData.seriesHasData"
					[chartData]="selectedGraphData.chartObj"
					[chartConfigurationObj]="selectedGraphData.chartObjConfig"
				></app-donut>
				<div *ngIf="!selectedGraphData || !selectedGraphData.seriesHasData" class="device-metric-no-data">
					No Data Available
				</div>
			</div>
		</div>
		<div class="card card1 mLeft devices-carousel creative-performance-stats display-creative-container">
			<app-loader [showLoader]="showLoad"></app-loader>
			<div class="devices-data-container height-100p" *ngIf="hasData">
				<div class="device-breakdown-data">
					<div *ngIf="checkFor('clicks')">
						<div class="devices-header-row">
							<div class="width-33p device-data">Device</div>
							<div class="width-33p device-data">Clicks</div>
						</div>
						<div class="devices-body">
							<div *ngFor="let device of deviceData; let index = index">
								<div
									class="width-33p device-data font-600p"
									[ngClass]="{
										'primary-color': index === 0,
										'secondary-color': index === 1,
										'tertiary-color': index === 2
									}"
								>
									{{ device.device }}
								</div>
								<div
									class="width-33p device-data"
									[ngClass]="{
										'primary-color': index === 0,
										'secondary-color': index === 1,
										'tertiary-color': index === 2
									}"
								>
									<div *ngIf="device.clicks">{{ device.clicks | formatNumber }}</div>
									<div *ngIf="!device.clicks">--</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="no-data-container" *ngIf="!hasData">
				<div class="map-no-data">No Data to Display</div>
			</div>
		</div>
	</div>
</div>
